import { Component, OnInit, ViewChild } from '@angular/core';
import { CanonicalService } from '../../../../shared/canonical.service';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { HttpService } from 'src/app/http.service';
import { environment } from '../../../../../environments/environment';
import { Router } from '@angular/router';
import * as moment from 'moment';


function ValidateEmail(control: AbstractControl): { [key: string]: Boolean } | null {

  // let regularExp = /^([\w.-]+)@(\[(\d{1,3}\.){3}|(?!hotmail|gmail|yahoo|outlook)(([a-zA-Z\d-]+\.)+))([a-zA-Z]{2,4}|\d{1,3})(\]?)$/;
  let regularExp = /^([\w.-]+)@((?!hotmail|gmail|yahoo|outlook)([a-zA-Z\d-]+\.)+)([a-zA-Z]{2,4}|\d{1,3})(\]?)$/;

  if (control.value !== undefined && !regularExp.test(control.value)) {
    return { "isValidEmail": true };
  }
  return null;
}
@Component({
  selector: 'app-enhancing-mobile-app-security-through-rasp',
  templateUrl: './enhancing-mobile-app-security-through-rasp.component.html',
  styleUrls: ['./enhancing-mobile-app-security-through-rasp.component.css']
})
export class EnhancingMobileAppSecurityThroughRaspComponent implements OnInit {
  @ViewChild('closebutton') closebutton: any;
  heading = "Enhancing Mobile App Security Through RASP";
  subheading = "";
  cilentIPAddress = "";
  innerWidth:number = window.innerWidth;
  demoSubmitted = false;
  demoForm: FormGroup;
  currentRoutePath: any;

  constructor(private canonicalService: CanonicalService, public fb: FormBuilder, private httpService: HttpService,private router: Router) { 
    this.canonicalService.setCanonicalURL("https://www.protectt.ai/enhancing-mobile-app-security-through-rasp");
    this.currentRoutePath = this.router.url;
    this.httpService.getIPAddress().subscribe((res: any) => {
      this.cilentIPAddress = res.ip;
    });
    this.demoForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]{1,64}@[a-z0-9.-]+\\.[a-z]{2,4}$'), ValidateEmail])],
      name: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.pattern('^[A-Za-z ]+$')])],
      designation: ['', Validators.compose([Validators.required, Validators.maxLength(50)])],
      message: [''],
      contactnumber: ['', Validators.compose([Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")])],
      company_name: ['', Validators.compose([Validators.required])],
      time_slot1: ['', Validators.compose([Validators.required])],
      time_slot2: ['', Validators.compose([Validators.required])],
    });
  }

  ngOnInit(): void {
  }
  onResize(event:any){
    this.innerWidth = event.target.innerWidth;
  }
  onReset() {

    this.demoForm.reset();
    this.demoSubmitted = false;
  }

  submitDemoForm() {
    let dateString1 = this.demoForm.get('time_slot1')!.value;
    let dateString2 = this.demoForm.get('time_slot2')!.value;
    var dateTimeSlot1 = moment(dateString1).format('DD-MM-YYYY HH:MM');
    var dateTimeSlot2 = moment(dateString2).format('DD-MM-YYYY HH:MM');
    let url = environment.API_URL + "requestdemo";
    let urlValue = "";
    this.demoSubmitted = true;
    if (this.demoForm.invalid) {
      return;
    } else {
      if (url.includes("dev.website")) {
        urlValue = "nonprod"
      } else {
        urlValue = "prod"
      }
      var demoData = {
        email: this.demoForm.get('email')!.value,
        name: this.demoForm.get('name')!.value,
        designation: this.demoForm.get('designation')!.value,
        message: this.demoForm.get('message')!.value,
        contactnumber: this.demoForm.get('contactnumber')!.value,
        companyname: this.demoForm.get('company_name')!.value,
        timeslot1: dateTimeSlot1,
        timeslot2: dateTimeSlot2,
        ipaddress: this.cilentIPAddress,
        weburl: urlValue,
        adcampurl: this.currentRoutePath
      };
      let data = {
        salesLeadData: demoData,
      }
      let encryptMsg = JSON.stringify(data);
      let encMsg = this.httpService.encryptText(encryptMsg, HttpService.SECRET_KEY);
      let postData = {
        encryptedRequest: encMsg
      }

      this.httpService.postAPIMethod(url, postData).subscribe(
        res => {
          let decRes = this.httpService.decryptText(res, HttpService.SECRET_KEY);
          let decMsg = decRes;
          let resp: any = JSON.parse(decMsg);
          alert(resp['statusDesc']);
          // this.subRespData = JSON.parse(decMsg);
        },
        error => {
        });

      this.demoSubmitted = false;
      // alert("Request has been submitted..");
      this.closebutton.nativeElement.click();
    }
  }
  get getDemoForm() {
    return this.demoForm.controls;
  }
}
